// extracted by mini-css-extract-plugin
export default {"fullPageLoader":"FullPageSpinner_component_fullPageLoader__a4Go6"};